// extracted by mini-css-extract-plugin
export default {"leiloes":"Auctions_leiloes__v0l+a"};